import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET_ALL: 'FEEDBACK_TAGS_GET_ALL',
  GET_ALL_SUCCESS: 'FEEDBACK_TAGS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'FEEDBACK_TAGS_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(
  () => `${BASE_URL}/student-classrooms/feedback-tags/`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
